export const Application = {
    Daemon: 'LucidDaemon',
    Android: 'LucidAndroidApp',
    iOS: 'LucidIOSApp',
    Desktop: 'LucidDesktopApp',
    Web: 'LucidWebApp',
    WebService: 'LucidWebService',
    LucidSdk: 'LucidSdk',
    LucidApi: 'LucidApi',
    LucidPython: 'LucidPythonSDKBeta',
};
export const Platform = {
    ANDROID: 'Android',
    IOS: 'iOS',
    WEB: 'Web',
    WINDOWS: 'Windows',
    LINUX: 'Linux',
    OSX: 'OSX',
    NODE_JS: 'NodeJS',
};
export const Platforms = Object.values(Platform);
export const PLATFORM_HEADER_NAME = 'LucidLink-Platform';
export const APPLICATION_HEADER_NAME = 'LucidLink-Application';
